import { ApplicationForm, LinkType } from '@/../../common/src/utils/nativeApi/interface';

// byClaude-start 2026-07-01 13:36:18
/** 通用 Y/N 枚举 */
export enum BoolString {
  YES = 'Y',
  NO = 'N',
}

/** 通用 true/false 字符串枚举 */
export enum BooleanString {
  YES = 'true',
  NO = 'false',
}

/** 银行类型 */
export enum BankTypeEnum {
  BOC = 'BOC', // 中国银行
  HSBC = 'HSBC', // 汇丰
  SCB = 'SCB', // 渣打
  CITI = 'CITI', // 花旗
}

/** OTP 验证结果类型 */
export enum OtpResultType {
  EXPIRE = '01', // 失效
  FAIL = '02', // 不匹配
  SUCCESS = '03', // 成功
  OVER_LIMIT = '04', // 超出次數
}

/** 贷款类型 */
export enum LoanType {
  ClearCard = '01', // 信用卡
  CashLoan = '02', // 儲蓄卡
}

/** 通用结果状态枚举 */
export enum ResultStatusType {
  SUCCESS = 'success',
  FAIL = 'fail',
  PENDING = 'pending',
}

/** 优惠券类型 */
export enum CouponType {
  FreeCoupon = '01', // 免息券
  DiscountCoupon = '02', // 利息折扣券
  ReduceInterestCoupon = '03', // 减息券
  CashCoupon = '04', // 现金回贈券
  ConcertCoupon = '05', // 音乐会兑换券
  InterestRewardCoupon = '06', // 利息回贈券
  NewYearCoupon = '07', // 新年券
}

/** EDDA 绑定状态 */
export enum BankEddState {
  BindSuccess = '1',
  BindFail = '2',
  BindHandling = '3',
  Unbinding = '4',
  UnbindFail = '5',
  UnbindSuccess = '6',
  Pending = '7', // 外部系統等待中
}

/** 合约状态 */
export enum ContractState {
  OVERDUE = 2, // 逾期
  INEFFECT = 1, // 待还款
  REPAYING = -1, // 还款中
  REPAYED = 3, // 已还清
  FAIL = 4, // 貸款失敗
  PENDING = 5, // 处理中
}

/** 账单管理状态 */
export enum BillMamtState {
  EKYCNOTYET = '0',
  INFOSUBMITED = '1',
  BILLADMITING = '2',
  FAIL = '3',
  SUCCESS = '4',
  WITHDRAWAL = '5',
  BILLSUCCESS = '6',
  BILLFAIL = '7',
  EKYCFINISH = '8',
  NAMEApproving = '11',
  NAMEAPPROVAL_FAIL = '11-2',
  NAMEAPPROVAL_REJECT = '11-3',
  EKYCApproving = '10',
  CMC_EKYC_APPROVE = '13',
}
// byClaude-end 2026-07-01 13:36:18

export type SystemNoticeType = {
  endTime: string; // 结束时间
  notice: string; // 通知文案
  startTime: string; // 开始时间
  title: string; // 通知标题
  type: string; // 通知类型
};

export enum QuestionType {
  Normal = '0', // 常规问题
  CancelAccount = '1', // 注销账号
  DeleteAccount = '2', // 删除帐户
  CancelBillMgmt = '3', // 取消账单管理
}

export interface QuestionDto {
  id: number;
  question: string;
  answer: string;
  type: QuestionType;
  problemType: string;
}

export enum QuestionFromType {
  BillMgmt = '2', // 账单管理
  CL = '4', // CL
}

export type BillStateType = {
  isCloseBill: BillState; // 是否已关闭账单管理  1是 2否
  isCloseReptile: BillState; // 是否已关闭字段爬虫  1是 2否
};

export enum BillState {
  OPEN = 2, // 开通
  CLOSE = 1, // 关闭
}

export type ChannelManagementDto = {
  banner: string; // 顶部banner
  bannerEn: string; // 英文-顶部banner
  bannerPc: string; // pc Banner
  bannerPcEn: string; // pc Banner 英文
  channelId: string; // Channel ID
  channelName: string; // 渠道名称
  id: string; // 主键id
  invitationCode: string; // 邀请码
  logo: string; // LOGO
  logoEn: string; // 英文-LOGO
  logoLink: string; // 合作方的页面
  protocolLink: string; // 协议连接
  protocolLinkEn: string; // 英文-协议连接
  protocolName: string; // 协议名称
  protocolNameEn: string; // 英文-协议名称
  linkType?: LinkType; // 鏈接類型
  // byClaude-start 2026-08-13 13:56:41 申请表单类型（与 linkType 平级），FULL_FORM 代表全流程
  applicationForm?: ApplicationForm; // 申请表单类型
  // byClaude-end 2026-08-13 13:56:41
};

// 掩碼銀行，作爲模板  111111******2222，用於填寫空白
export type PatternBankNum = {
  bankNum: string;
  billId: number;
  defaultValue?: string;
};

export enum ProtocolType {
  BorrowerDeclaration, // 借款人声明
  Credit, // 維信貸款條款及細則
  Mgm, // CreFIT推薦獎勵計劃（「推廣活動」）條款及細則
  MoneySmart, // CreFIT賞你「高達20%全期利息回贈優惠」（“本推廣”）之條款及細則
  Palbms, // 個人賬戶連結及賬單管理服務之條款及細則
  Pics, // 個人信息收集聲明
  PrivacyAgreement, // 私隱政策聲明
  Promotion, // CreFIT賞你「高達20%全期利息回贈優惠」（“本推廣”）之條款及細則
  Remark, // 備註
  UserPolicy, // 流動應用程式與網站使用條款
  Cs, // 維信金融財務有限公司線上客戶服務之使用條款
  ClPromotion, // CL 推廣活動
  Hummingbird, // 蜂鸟
  // byClaude-start 2026-07-01 12:00:00
  DebtDeclaration, // 信務聲明（低收入债务申报）
  // byClaude-end
}

// 后台协议列表维护的name值
export const ProtocolNameMap = {
  [ProtocolType.BorrowerDeclaration]: 'borrowerDeclaration',
  [ProtocolType.Credit]: 'pubCredit',
  [ProtocolType.Mgm]: 'mgm',
  [ProtocolType.MoneySmart]: 'promotion',
  [ProtocolType.Palbms]: 'palbms',
  [ProtocolType.Pics]: 'infoCollection',
  [ProtocolType.PrivacyAgreement]: 'privacyAgreement',
  [ProtocolType.Promotion]: 'promotion',
  [ProtocolType.Remark]: 'remark',
  [ProtocolType.UserPolicy]: 'userPolicy',
  [ProtocolType.Cs]: 'cs',
  [ProtocolType.ClPromotion]: 'clpromotion',
  [ProtocolType.Hummingbird]: 'hummingbird',
  // byClaude-start 2026-07-01 12:00:00
  [ProtocolType.DebtDeclaration]: 'debtDeclaration',
  // byClaude-end
};

// 对应的title的国际化key值
export const ProtocolTypeTitleMap = {
  [ProtocolType.BorrowerDeclaration]: 'pub_borrow_declaration',
  [ProtocolType.Credit]: 'pub_credit',
  [ProtocolType.Mgm]: 'pub_mgm',
  [ProtocolType.MoneySmart]: 'pub_promotion',
  [ProtocolType.Palbms]: 'pub_palbms_title',
  [ProtocolType.Pics]: 'pub_pisc_title',
  [ProtocolType.PrivacyAgreement]: 'pub_privacy',
  [ProtocolType.Promotion]: 'pub_promotion',
  [ProtocolType.Remark]: 'pub_remark',
  [ProtocolType.UserPolicy]: 'pub_userPolicy',
  [ProtocolType.Cs]: 'pub_cs',
  // byClaude-start 2026-07-01 12:00:00
  [ProtocolType.DebtDeclaration]: 'pub_debt_declaration',
  // byClaude-end
};

// app 协议
export type ProtocolRequestDto = Partial<{
  bodyCn: string; // 协议内容 繁
  bodyEn: string; // 协议内容（英）
  bodyZh: string; // 协议内容（简）
  id: string; // 用户id，自增
  isDesc: boolean; // 是否倒序，倒序为true 默认true
  nameCn: string; // 协议名称（繁）
  nameEn: string; // 协议名称（英）
  nameZh: string; // 协议名称（简）
  pageNum: number; // 页码
  pageSize: number; // 每页数量
  protocolId: string; // 协议id
  sort: string; // 排序字段
  state: string; // 状态 01 生效中 02 失效
  type: string; // 类型 01 app
  urlCn: string; // 协议链接（繁）
  urlEn: string; // 协议链接（英）
  urlZh: string; // 协议链接（简）
}>;

export enum ABTestType {
  OLD = 'A', // 原功能
  NEW = 'B', // 新功能
}

interface submitFunctionType {
  (): Promise<any>;
}

export interface CompRef {
  getSubmitData: submitFunctionType;
}

export type UpdatePhoneDto = Partial<{
  birthday: string; // 生日
  blockList: any; // 黑名单
  code: string; // 验证码 OTP验证是必给
  englishName: string; // 英文名
  idCard: string; // 身份证号码
  newPhone: string; // 新手机号 OTP验证是必给
  oldPhone: string; // 用户手机号 OTP验证是必给
  otpResult: OtpResultType; // 校验结果
  smsType: string; // smsType 07 APP修改手機號 OTP验证是必给
  state: UpdatePhNumState; // state
  transactionId: string; // transactionId OTP验证是必给
  userId: number;
}>;

export enum UpdatePhNumState {
  DRAFT = 0, // 草稿
  FAIL = 1, // 拒絕
  NO_OTP = 2, // 未OTP
  APPROVAL = 3, // 審批中
  SUCCESS = 4, // 修改成功
}

export enum SmsType {
  Register = '02', // 登录注册页
  CmcCredit = '05', // CMC 授信 OTP
  CmcUpdatePhone = '06', // CMC 修改手机号
  UpdatePhone = '07', // 更改电话号码
}
export type AppliedProduction = {
  isApplyCl: BoolString;
  isApplyKkc: BoolString;
  isApplyCmc: BoolString;
};

export enum ReceiveStateType {
  UNCLAIMED = 'UNCLAIMED', // 未领取
  SUCCESS = 'SUCCESS', // 已领取
}

export enum RewardType {
  CODE_A = 'CODE_A', // 未领取
  CODE_B = 'CODE_B', // 已领取
}

export enum ActivityStateType {
  NO_START = 'NO_START', // 未开始
  END = 'END', // 已结束
  RUN = 'RUN', // 进行中
}

// 年宵活动奖励记录详情
export type RewardDetail = {
  id: string;
  phone: string;
  festivalId: number;
  receiveState: ReceiveStateType;
  rewardType: RewardType;
  receiveTime?: string;
};

// 年宵活动主数据结构
export type FestivalData = {
  id: string;
  phone: string;
  festivalType: string;
  activityState?: ActivityStateType;
  userName: string;
  idCard: string;
  dateOfBirth: string;
  customerType: string;
  list: RewardDetail[];
  channelId: string;
};
// 通用结果类型（爬虫的单独处理）
export enum CommonResultType {
  ClApprovalFail = 'ClApprovalFail',
  ClEddaFail = 'ClEddaFail',
  ClPending = 'ClPending',
  ClAppealPending = 'ClAppealPending',
  ClLoanFail = 'ClLoanFail',
  KkcApplyFail = 'KkcApplyFail',
  KkcApplyFailShowCl = 'KkcApplyFailShowCl',
  KkcApplyPending = 'KkcApplyPending',
  KkcLoanPending = 'KkcLoanPending',
  KkcAppealPending = 'KkcAppealPending',
  KkcLoanFail = 'KkcLoanFail',
  KkcAppealFail = 'KkcAppealFail',
  KkcStudentPending = 'KkcStudentPending',
  BillMgmtReportsPending = 'BillMgmtReportsPending',
  BillMgmtPaymentSuccess = 'BillMgmtPaymentSuccess',
  BillMgmtPaymentFailure = 'BillMgmtPaymentFailure',
  BillMgmtPaymentInitialFail = 'BillMgmtPaymentInitialFail',
  CmcProcessNavigate = 'CmcProcessNavigate',
  CmcMoreFunction = 'CmcMoreFunction',
  CmcMoreFunctionFail = 'CmcMoreFunctionFail',
  CmcApprovalFail = 'CmcApprovalFail',
  CmcEddaFail = 'CmcEddaFail',
  CmcCrossLoan = 'CmcCrossLoan',
  CmcPending = 'CmcPending',
  CmcLoanFail = 'CmcLoanFail',
  UploadPending = 'UploadPending',
  UpdatePhonePending = 'UpdatePhonePending',
  UpdatePhoneFail = 'UpdatePhoneFail',
  UpdatePhoneSuccess = 'UpdatePhoneSuccess',
}

export enum EkycScene {
  CHECK_INFO = 'CHECK_INFO', // 核对资料验证
  LOGIN_INFO = 'LOGIN_INFO', // 一键WhatsApp
}

// 新客活動類型
export enum NewUserActivityType {
  TypeA = 'NewCusActA', // A類型：展示进度条Bubble
  TypeB = 'NewCusActB', // B類型：展示顶部提示
  TypeC = 'NewCusActC', // C類型：无提示
  TypeD = 'NewCusActD', // D類型：无提示
}

export enum activityProgressType {
  UN_START = 'UN_START', // 未开始
  REGISTER_SUCCESS = 'REGISTER_SUCCESS', // 注册成功
  EKYC_SUCCESS = 'EKYC_SUCCESS', // ekyc成功
  CONFIRM_SUCCESS = 'CONFIRM_SUCCESS', // 确认信息成功
  CREDIT_PASS = 'CREDIT_PASS', // 授信通过
  REJECT = 'REJECT', // 授信拒绝
}

// 新客限時優惠活動進度查詢
export type NewUserActivityInfo = {
  registerActCode: NewUserActivityType;
  activityProgress: activityProgressType;
  earnedRewardAmount: number;
  pendingRewardAmount: number;
};

export enum activityLocationType {
  VICTORIA_PARK = 'VICTORIA_PARK', // 维多利亚公园
  FA_HUI_PARK = 'FA_HUI_PARK', // 太子花墟公园
  SHA_TSUI_ROAD_PLAYGROUND = 'SHA_TSUI_ROAD_PLAYGROUND', // 荃湾沙咀道游乐场
}

// Contains claude-generated edits.
